import * as Urls from 'lib/urls'
import fetch from 'lib/fetch'

const GET = 'GET'

export const getPostsByNumberOfWeeksPregnant = (
  numberOfWeeksPregnant: number
) =>
  fetch(
    `${Urls.apiV3PostsByNumberOfWeeksPregnantPath}?number_of_weeks_pregnant=${numberOfWeeksPregnant}`,
    {
      method: GET,
    }
  )
